import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/tokens.css';
import './styles/theme-tokens.generated.css';
import './index.css';
import App from './App';
import AppBrandMark from './components/AppBrandMark';
import { auth, db } from './firebase';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { installControllerChangeReload } from './utils/appUpdate';

const root = ReactDOM.createRoot(document.getElementById('root'));

if (!auth || !db) {
  root.render(
    <div style={{ padding: '2rem', fontFamily: 'sans-serif', textAlign: 'center' }}>
      <h1>
        <AppBrandMark size="compact" />
      </h1>
      <p style={{ color: 'var(--tk-text-c62828)' }}>
        Firebase is not configured. Add REACT_APP_FIREBASE_API_KEY, AUTH_DOMAIN, and PROJECT_ID in Vercel project Environment Variables, then redeploy.
      </p>
    </div>
  );
} else {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

// App-shell service worker: precaches the build so the Care app is installable
// as a PWA (Add to Home Screen) and loads instantly on repeat visits. When a
// new build is deployed, ServiceWorkerUpdateBanner prompts the user to refresh
// (long-lived tabs otherwise keep running the old bundle indefinitely).
installControllerChangeReload();
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    window.__swWaitingRegistration = registration;
    window.dispatchEvent(new CustomEvent('sw-update-available', { detail: registration }));
  },
});
